import { TravelEvents } from './travelEvents';

export class EventsInfo{
    travelCount: number;
    kilometersCount: number;
    metersCount: number;
    hoursCount: number;
    secondsCount: number;
    eventCount: number;
    eventSpeedingCount: number;
    eventHardAccelerationCount: number;
    eventHardBrakeCount: number;
    eventNightTimeCount: number;
    events: Array<TravelEvents>;
    lastUpdate: string = '';
}
